module.exports = __webpack_public_path__ + "img/album18_01.48c7a941.jpg";